// extracted by mini-css-extract-plugin
export default {"header__nav":"Navigation_header__nav__FCxKE","navlink":"Navigation_navlink__zOl4w"};